// FK-5112 BOM PDF REPORT GENERATOR v4.4
// Updated titles, tubing display, footer normal font
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { addPipeNetworkPages } from "./pipeNetworkPDF";
import { addFlowPerformancePages } from "./flowPerformancePDF";
import { LOGO_BASE64, LOGO_FORMAT } from "./boalLogo";
export { LOGO_BASE64, LOGO_FORMAT };

var BRAND_RED = [139, 30, 30], BRAND_NAVY = [26, 39, 68], GRAY = [100, 100, 100], WHITE = [255, 255, 255];
var VER = "2.3.0";

function fmtDate() { return new Date().toISOString().replace("T", " ").slice(0, 19); }

function addFooter(doc, pg) {
  var pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight();
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor.apply(doc, GRAY);
  doc.text("Software Version " + VER + "    Calculation Performed: " + fmtDate() + " EST", pw / 2, ph - 15, { align: "center" });
  doc.text("Page " + pg, pw - 20, ph - 15, { align: "right" });
  doc.text("Copyright \u00A9 Boal Systems Inc. Fort Lauderdale, FL USA", pw / 2, ph - 10, { align: "center" });
}

function addLogo(doc, x, y, w, h) {
  try {
    if (LOGO_BASE64) {
      doc.setFillColor(255, 255, 255);
      doc.rect(x, y, w, h, "F");
      doc.addImage(LOGO_BASE64, LOGO_FORMAT || "JPEG", x, y, w, h);
    }
  } catch (e) {}
}

function lv(doc, label, value, x, y, lw) {
  doc.setFont("helvetica", "normal"); doc.setTextColor.apply(doc, GRAY);
  doc.text(label, x, y); doc.setTextColor(0, 0, 0);
  doc.text(String(value || "\u2014").substring(0, 60), x + (lw || 42), y);
}

export function generateBOMReport(form, result, isMetric, pipeNetworks) {
  var doc = buildDoc(form, result, isMetric, pipeNetworks);
  var _prefix = (form.projectName || "FK5112").replace(/[^a-zA-Z0-9_-]/g, "_");
  var _suffix = (result.reportTitle && result.reportTitle.indexOf("Total Flooding") >= 0) ? "_Boal_TotalFlood_System_Report" : "_Boal_MicroSupp_System_Report";
  doc.save(_prefix + _suffix + ".pdf");
}

export function generateBOMReportBase64(form, result, isMetric, pipeNetworks) {
  var doc = buildDoc(form, result, isMetric, pipeNetworks);
  var prefix = (form.projectName || "FK5112").replace(/[^a-zA-Z0-9_-]/g, "_");
  var suffix = (result.reportTitle && result.reportTitle.indexOf("Total Flooding") >= 0) ? "_Boal_TotalFlood_System_Report" : "_Boal_MicroSupp_System_Report";
  var fn = prefix + suffix + ".pdf";
  return { base64: doc.output("datauristring").split(",")[1], fileName: fn, mimeType: "application/pdf" };
}

function buildDoc(form, result, isMetric, pipeNetworks) {
  var isMicro = !!(result.enclosureResults);
  var isTF = !!(result.enclosureResults && result.reportTitle && result.reportTitle.includes("Total Flooding"));
  var isMicroOnly = isMicro && !isTF;

  // Dynamic titles
  var pageTitle = isMicroOnly ? "FK 5112 Micro Suppression System Report" : "FK 5112 Suppression System Report";
  var headerText = pageTitle;
  var bomTitle = result.reportTitle || "System BOM";

  var encR = result.enclosureResults || [];
  var aggBom = result.aggregatedBom || result.bom || [];
  var doc = new jsPDF("p", "mm", "letter");
  var pw = doc.internal.pageSize.getWidth(), m = 20;
  var uL = isMetric ? "m" : "ft", uT = isMetric ? "\u00B0C" : "\u00B0F", uV = isMetric ? "m\u00B3" : "ft\u00B3";
  var pg = 1;

  // === PAGE 1 ===
  addLogo(doc, pw / 2 - 20, 10, 40, 40);
  doc.setFontSize(16); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_NAVY);
  doc.text(pageTitle, pw / 2, 60, { align: "center" });
  doc.setFontSize(14); doc.setTextColor(0, 0, 0);
  doc.text(form.company || form.designerName || "\u2014", pw / 2, 72, { align: "center" });

  var y = 84;
  doc.setFontSize(10);
  [["Designer:", form.designerName], ["Email:", form.email], ["Phone:", form.phone]].forEach(function(p) {
    doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_RED); doc.text(p[0], m, y);
    doc.setFont("helvetica", "normal"); doc.setTextColor(0, 0, 0); doc.text(String(p[1] || "\u2014"), m + 35, y); y += 6;
  });

  // Project info
  y += 4; doc.setFontSize(12); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_RED);
  doc.text("Project Information", pw / 2, y, { align: "center" }); y += 8; doc.setFontSize(9);
  [["Project Name:", form.projectName], ["Location:", form.projectLocation], ["Country:", form.country], ["Notes:", form.notes]].forEach(function(p) { lv(doc, p[0], p[1], m, y, 35); y += 5.5; });

  // Design requirements
  y += 4; doc.setFontSize(12); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_RED);
  doc.text("Design Requirements", pw / 2, y, { align: "center" }); y += 8; doc.setFontSize(9);
  var lc = m, rc = pw / 2 + 5;
  var left = [["Unit System:", isMetric ? "Metric" : "Imperial"], ["Elevation:", (form.elevation || "\u2014") + " " + uL], ["Min Temperature:", (form.minTemp || "\u2014") + " " + uT], ["Max Temperature:", (form.maxTemp || "\u2014") + " " + uT], ["Concentration:", (form.concentration || "\u2014") + " %"]];
  var right = [["Cylinder Config:", form.cylinderConfig || "\u2014"], ["Detection Type:", form.detectionType || "\u2014"], ["Pressure Supervisor:", form.pressureSupervisor || "\u2014"]];
  if (isMicroOnly) {
    left.push(["Airtight:", form.isAirtight || "\u2014"]);
    if (form.supervisableSolenoid) right.push(["Solenoid:", form.supervisableSolenoid]);
  } else {
    right.push(["Solenoid:", form.supervisableSolenoid || "\u2014"]);
    right.push(["Cylinder Color:", form.cylinderColor || "\u2014"]);
    right.push(["Nozzle Type:", form.nozzleType || "\u2014"]);
    right.push(["LLI:", form.lli || "\u2014"]);
    right.push(["Discharge Sup:", form.dischargeSupervisor || "\u2014"]);
  }
  var mx = Math.max(left.length, right.length);
  for (var i = 0; i < mx; i++) { if (i < left.length) lv(doc, left[i][0], left[i][1], lc, y); if (i < right.length) lv(doc, right[i][0], right[i][1], rc, y); y += 5.5; }

  // Enclosure details
  if (encR.length > 0) {
    y += 4; doc.setFontSize(12); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_RED);
    doc.text("Enclosure Details", pw / 2, y, { align: "center" }); y += 4;
    if (isTF) {
      var tfRows = [];
      for (var ei = 0; ei < encR.length; ei++) {
        var er = encR[ei];
        tfRows.push([{ content: er.name, rowSpan: 3, styles: { fontStyle: "bold", valign: "middle" } }, "Main Area", String(er.mainL || ""), String(er.mainW || ""), String(er.mainH || ""), String(er.volume) + " " + uV]);
        tfRows.push(["Raised Floor", String(er.floorL || ""), String(er.floorW || ""), String(er.floorH || ""), ""]);
        tfRows.push(["False Ceiling", String(er.ceilingL || ""), String(er.ceilingW || ""), String(er.ceilingH || ""), ""]);
      }
      autoTable(doc, { startY: y, head: [["Enclosure", "Area", "L (" + uL + ")", "W (" + uL + ")", "H (" + uL + ")", "Total Vol"]], body: tfRows, margin: { left: m, right: m }, headStyles: { fillColor: BRAND_RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 }, bodyStyles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 28 }, 1: { cellWidth: 25 } } });
    } else {
      var mRows = [];
      for (var mi = 0; mi < encR.length; mi++) { var mr = encR[mi]; mRows.push([String(mi + 1), mr.name, String(mr.l || ""), String(mr.w || ""), String(mr.h || ""), String(mr.volume) + " " + uV]); }
      autoTable(doc, { startY: y, head: [["#", "Enclosure", "L (" + uL + ")", "W (" + uL + ")", "H (" + uL + ")", "Volume"]], body: mRows, margin: { left: m, right: m }, headStyles: { fillColor: BRAND_RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 }, bodyStyles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 10, halign: "center" }, 1: { cellWidth: 30 } } });
    }
  }
  addFooter(doc, pg);

  // === PAGE 2: Per-Enclosure ===
  if (encR.length > 0) {
    doc.addPage(); pg++;
    addLogo(doc, m, 8, 25, 25);
    doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
    doc.text(headerText, m + 28, 18);
    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_NAVY);
    doc.text(bomTitle, pw / 2, 42, { align: "center" });
    doc.setFontSize(11); doc.text("Per-Enclosure Breakdown", m, 54);
    y = 60;
    for (var j = 0; j < encR.length; j++) {
      var enc = encR[j];
      if (y > 220) { addFooter(doc, pg); doc.addPage(); pg++; y = 20; }
      doc.setFontSize(9); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_NAVY);
      var hdr = enc.name + "  |  FK 5112: " + enc.agentLbs + " lbs  |  Cyl: " + enc.model + " x " + enc.cylCount;
      // Add tubing info for microsuppression
      if (isMicroOnly && enc.tubingMeters > 0) hdr += "  |  Tubing: " + Math.round(enc.tubingMeters) + "m";
      doc.text(hdr, m, y);
      if (enc.nozzleCount > 0) { doc.setFont("helvetica", "normal"); doc.setTextColor.apply(doc, GRAY); doc.text("Nozzles: " + enc.nozzleCount, pw - m, y, { align: "right" }); }
      y += 3;
      autoTable(doc, {
        startY: y,
        head: [["Part Number", "Description", "Qty"]],
        body: enc.items.map(function(item) { return [item.pn, item.desc, String(item.qty)]; }),
        margin: { left: m, right: m },
        headStyles: { fillColor: BRAND_RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 },
        bodyStyles: { fontSize: 8, textColor: [50, 50, 50] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        columnStyles: { 0: { cellWidth: 50, fontStyle: "bold" }, 2: { cellWidth: 15, halign: "center" } },
      });
      y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y + 20) + 8;
    }
    addFooter(doc, pg);
  }

  // === AGGREGATED BOM ===
  doc.addPage(); pg++;
  addLogo(doc, m, 8, 25, 25);
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text(headerText, m + 28, 18);
  doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, BRAND_NAVY);
  doc.text(bomTitle, pw / 2, 42, { align: "center" });
  y = 54; doc.setFontSize(11); doc.text(encR.length > 0 ? "Aggregated Project BOM \u2014 Order Summary" : "System BOM", m, y); y += 4;
  if (encR.length > 0 && result.totalAgent) {
    doc.setFontSize(9); doc.setFont("helvetica", "normal"); doc.setTextColor.apply(doc, GRAY);
    var summaryLine = "Total FK 5112: " + result.totalAgent + " Lbs  |  Cylinders: " + encR.reduce(function(s, r) { return s + r.cylCount; }, 0) + "  |  Enclosures: " + encR.length;
    // Add total tubing for microsuppression
    if (isMicroOnly) {
      var totalTubing = encR.reduce(function(s, r) { return s + (r.tubingMeters || 0); }, 0);
      if (totalTubing > 0) summaryLine += "  |  Total Tubing: " + Math.round(totalTubing) + "m";
    }
    doc.text(summaryLine, m, y + 2); y += 8;
  }
  autoTable(doc, {
    startY: y,
    head: [["Part Number", "Description", "Qty"]],
    body: aggBom.map(function(row) { return [row.pn, row.desc, String(row.qty)]; }),
    margin: { left: m, right: m },
    headStyles: { fillColor: BRAND_RED, textColor: WHITE, fontStyle: "bold", fontSize: 9 },
    bodyStyles: { fontSize: 9, textColor: [30, 30, 30] },
    alternateRowStyles: { fillColor: [240, 240, 240] },
    columnStyles: { 0: { cellWidth: 50, fontStyle: "bold" }, 2: { cellWidth: 18, halign: "center", fontStyle: "bold" } }
  });

  // Nozzle mismatch note
  if (isTF && pipeNetworks && Object.keys(pipeNetworks).length > 0) {
    var hasMismatch = encR.some(function(r, idx) { var pn = pipeNetworks[idx]; return pn && pn.summary && pn.summary.nozzles !== r.nozzleCount; });
    if (hasMismatch) {
      var noteY = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y) + 8;
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(146, 64, 14);
      doc.text("* Nozzle quantities shown in BOM are based on customer\u2019s pipe network design.", m, noteY);
    }
  }
  addFooter(doc, pg);

  // === PIPE NETWORK PAGES ===
  if (isTF && pipeNetworks && Object.keys(pipeNetworks).length > 0) {
    try { pg = addPipeNetworkPages(doc, encR, pipeNetworks, uL, LOGO_BASE64, pg); } catch (e) { console.error("Pipe network PDF error:", e); }
  }

  // === FLOW PERFORMANCE PAGES ===
  if (result.flowResults && Object.keys(result.flowResults).length > 0) {
    try { pg = addFlowPerformancePages(doc, encR, result.flowResults, LOGO_BASE64, LOGO_FORMAT, pg); } catch (e) { console.error("Flow performance PDF error:", e); }
  }

  return doc;
}
